import { format } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatNumericValue } from 'utils/general';

import { useGetWorkforceWidgets } from '@/modules/home/apiHooks';
import { useHomePageContext } from '@/modules/home/context';
import { Widget } from '@/shared/components/atoms';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import BlueUser from '~/images/shared/BlueUser.svg';
import CheckedLightBlueUser from '~/images/shared/CheckedLightBlueUser.svg';

const WorkforceNumbersWidgets = () => {
  const { t } = useTranslation('common');
  const [selectedAsset] = useStore((store) => store?.asset);
  const {
    state: { date },
  } = useHomePageContext();

  const { data } = useGetWorkforceWidgets({
    entityId: selectedAsset?.id,
    date: format(date, 'yyyy-MM-dd'),
  });

  return (
    <div className='flex flex-wrap justify-between gap-16 desktop:flex-nowrap'>
      <Widget
        title={t('active-workers')}
        number={
          data?.activeWorkers ? formatNumericValue(data.activeWorkers) : 0
        }
        icon={<CheckedLightBlueUser />}
        className='desktop:w-full'
      />
      <Widget
        title={t('active-supervisors')}
        number={
          data?.activeSupervisors
            ? formatNumericValue(data.activeSupervisors)
            : 0
        }
        icon={<BlueUser />}
        className='desktop:w-full'
      />
    </div>
  );
};
export { WorkforceNumbersWidgets };
